// import React from 'react';
// import { Box, Paper, Typography, Button } from '@mui/material';

// const AlertModal = ({ 
//   open, 
//   onClose, 
//   onConfirm, 
//   title = "Confirm Action",
//   message = "Are you sure you want to perform this action?",
//   confirmText = "OK",
//   cancelText = "Cancel"
// }) => {
//   if (!open) return null;

//   return (
//     <Box sx={{
//       position: 'fixed',
//       top: 0,
//       left: 0,
//       right: 0,
//       bottom: 0,
//       backgroundColor: 'rgba(0,0,0,0.5)',
//       zIndex: 9999,
//       display: 'flex',
//       justifyContent: 'center',
//       alignItems: 'center'
//     }}>
//       <Paper sx={{ padding: 3, maxWidth: 300, textAlign: 'center' }}>
//         <Typography variant="h6" gutterBottom>
//           {title}
//         </Typography>
//         <Typography variant="body1" sx={{ mb: 2 }}>
//           {message}
//         </Typography>
//         <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
//           <Button 
//             variant="outlined" 
//             onClick={onClose}
//           >
//             {cancelText}
//           </Button>
//           <Button 
//             variant="contained" 
//             color="primary"
//             onClick={onConfirm}
//           >
//             {confirmText}
//           </Button>
//         </Box>
//       </Paper>
//     </Box>
//   );
// };

// export default AlertModal;

import React from 'react';
import { Box, Paper, Typography, Button, IconButton } from '@mui/material';
import { Favorite, Close } from '@mui/icons-material';

const AlertModal = ({ 
  open, 
  onClose, 
  onConfirm, 
  title = "Confirm Action",
  message = "Are you sure you want to perform this action?",
  confirmText = "OK",
  cancelText = "Cancel",
  isSuccess = false // <-- NEW PROP to switch styles
}) => {
  if (!open) return null;

  return (
    <Box sx={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.4)', // Slightly lighter dim
      zIndex: 9999,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      px: 2
    }}>
      <Paper 
        sx={{ 
          padding: isSuccess ? '24px 20px' : 3, 
          width: '100%',
          maxWidth: 320, 
          textAlign: 'center',
          borderRadius: '16px',
          position: 'relative',
          boxShadow: '0px 4px 20px rgba(0,0,0,0.15)'
        }}
      >
        {isSuccess ? (
          // --- SUCCESS UI (Matches your screenshot) ---
          <>
            <IconButton onClick={onClose} sx={{ position: 'absolute', top: 8, right: 8, color: '#999' }}>
              <Close />
            </IconButton>

            <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
              <Box sx={{
                width: 60, height: 60, borderRadius: '50%', backgroundColor: '#FFF0E5',
                display: 'flex', justifyContent: 'center', alignItems: 'center'
              }}>
                <Favorite sx={{ color: '#8B4513', fontSize: 32 }} />
              </Box>
            </Box>

            <Typography variant="h6" sx={{ fontWeight: 700, color: '#333', mb: 1 }}>
              {title}
            </Typography>
            <Typography variant="body2" sx={{ color: '#666', mb: 3 }}>
              {message}
            </Typography>

            <Button 
              fullWidth
              variant="contained" 
              onClick={onClose}
              sx={{
                backgroundColor: '#8B4513', color: '#fff', borderRadius: '8px',
                textTransform: 'none', fontSize: '16px', fontWeight: 600, py: 1,
                '&:hover': { backgroundColor: '#703610' }
              }}
            >
              OK
            </Button>
          </>
        ) : (
          // --- CONFIRM UI (Your existing logic) ---
          <>
            <Typography variant="h6" gutterBottom>
              {title}
            </Typography>
            <Typography variant="body1" sx={{ mb: 2 }}>
              {message}
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
              <Button variant="outlined" onClick={onClose}>
                {cancelText}
              </Button>
              <Button variant="contained" color="primary" onClick={onConfirm}>
                {confirmText}
              </Button>
            </Box>
          </>
        )}
      </Paper>
    </Box>
  );
};

export default AlertModal;